(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-share"] && !Shopify.designMode) return;
  try {
    class ProductShare extends HTMLElement {
    connectedCallback() {
      this.url = this.dataset.url;
      this.title = this.dataset.title || document.title;
      this.toggle = this.querySelector('.product-share__toggle');
      this.menu = this.querySelector('.product-share__menu');
      this.copyBtn = this.querySelector('.product-share__opt--copy');
      this.copyLabel = this.querySelector('.product-share__copy-label');

      this.toggle.addEventListener('click', this.onToggle.bind(this));
      if (this.copyBtn) this.copyBtn.addEventListener('click', this.onCopy.bind(this));
      this._onOutside = this.onOutside.bind(this);
      document.addEventListener('click', this._onOutside);

      // Fijar el botón a la fila del precio (robusto ante Addi/MP que carguen
      // después): se posiciona absolute con la BASE en la base del número de precio.
      // Agrupado en un frame: resize/mutaciones seguidas = un solo cálculo de layout.
      this._pin = () => {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => {
          this._raf = null;
          this.pinToPrice();
        });
      };
      this._pin();
      window.addEventListener('resize', this._pin);
      var priceBlock = document.querySelector("[data-block-id$='price_a7krng']");
      if (priceBlock && 'MutationObserver' in window) {
        this._obs = new MutationObserver(this._pin);
        this._obs.observe(priceBlock, { childList: true, subtree: true });
      }
      // Reintentos por si Addi tarda en inyectar su widget.
      this._t1 = window.setTimeout(this._pin, 600);
      this._t2 = window.setTimeout(this._pin, 1800);
      this._t3 = window.setTimeout(this._pin, 3500);
    }

    disconnectedCallback() {
      if (this._pin) window.removeEventListener('resize', this._pin);
      if (this._onOutside) document.removeEventListener('click', this._onOutside);
      if (this._raf) cancelAnimationFrame(this._raf);
      if (this._obs) this._obs.disconnect();
      [this._t1, this._t2, this._t3].forEach(function (t) { if (t) window.clearTimeout(t); });
    }

    pinToPrice() {
      var wrapper = this.parentElement; // .shopify-block (ítem flex de la ficha)
      var details = this.closest('.product-details');
      var priceNum = document.querySelector("[data-block-id$='price_a7krng'] .price:not(.price__hidden *)");
      if (!wrapper || !details) return;
      // Solo en escritorio y si existe el precio; si no, se queda en el flujo.
      if (!window.matchMedia('(min-width: 750px)').matches || !priceNum) {
        wrapper.classList.remove('is-pinned');
        wrapper.style.top = '';
        wrapper.style.right = '';
        return;
      }
      details.style.position = 'relative';
      wrapper.classList.add('is-pinned');
      var dRect = details.getBoundingClientRect();
      var pRect = priceNum.getBoundingClientRect();
      var h = wrapper.offsetHeight;
      // Base del botón alineada con la base del número de precio; a la derecha.
      wrapper.style.top = Math.round(pRect.bottom - dRect.top - h) + 'px';
      wrapper.style.right = '0';
    }

    onToggle(e) {
      e.stopPropagation();
      // En móvil / navegadores con Web Share: menú nativo del sistema.
      if (navigator.share && window.matchMedia('(max-width: 749px)').matches) {
        navigator.share({ title: this.title, url: this.url }).catch(function () {});
        return;
      }
      var open = this.menu.hasAttribute('hidden');
      if (open) { this.menu.removeAttribute('hidden'); } else { this.menu.setAttribute('hidden', ''); }
      this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    onCopy(e) {
      e.preventDefault();
      var self = this;
      var done = function () {
        self.copyBtn.classList.add('is-copied');
        if (self.copyLabel) self.copyLabel.textContent = '¡Copiado!';
        window.setTimeout(function () {
          self.copyBtn.classList.remove('is-copied');
          if (self.copyLabel) self.copyLabel.textContent = 'Copiar enlace';
        }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.url).then(done).catch(function () {});
      } else {
        var t = document.createElement('textarea');
        t.value = this.url; document.body.appendChild(t); t.select();
        try { document.execCommand('copy'); done(); } catch (err) {}
        document.body.removeChild(t);
      }
    }

    onOutside(e) {
      if (!this.contains(e.target) && this.menu && !this.menu.hasAttribute('hidden')) {
        this.menu.setAttribute('hidden', '');
        this.toggle.setAttribute('aria-expanded', 'false');
      }
    }
  }
  if (!customElements.get('product-share')) customElements.define('product-share', ProductShare);
  } catch(e) { console.error(e); }
})();

})();
